import React, { useState } from "react";
import { Drawer, Menu } from "antd";
import I18n from "../../../../i18n";

type AppDraweProps = {
  visible: boolean;
  onClose: () => void;
  renderMenuItems: (openKeys: string[]) => JSX.Element | JSX.Element[];
};

export default function AppDrawer({
  visible,
  onClose,
  renderMenuItems,
}: AppDraweProps) {
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  return (
    <Drawer
      title={I18n.title}
      placement="right"
      closable={false}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ padding: 0 }}
    >
      <Menu
        mode="inline"
        selectable={false}
        onOpenChange={(keys) => setOpenKeys(keys as string[])}
      >
        {renderMenuItems(openKeys)}
      </Menu>
    </Drawer>
  );
}
